module.exports = __webpack_public_path__ + "img/inventory-log-book_B09PW14KW6.a63a323d.jpg";